import {useTranslation} from "@Translation/hooks/useTranslation";
import {
    singleModalTranslationKey
} from "@SearchResults/features/staticContent/constants/translationKeys";
import TipsPerTransportType from "@SearchResults/features/staticContent/components/TipsPerTransportType";

function VanTipsContent() {
    const title = useTranslation(`${singleModalTranslationKey}.vans.title`)
    const {
        title: subtitle,
        o1,
        o2,
        o3,
        o4,
        o5,
    } = useTranslation(`${singleModalTranslationKey}.vans.tips`)

    return (
        <TipsPerTransportType
            title={title}
            subtitle={subtitle}
            options={[
                {id: "van-o1", option: o1},
                {id: "van-o2", option: o2},
                {id: "van-o3", option: o3},
                {id: "van-o4", option: o4},
                {id: "van-o5", option: o5},
            ]}
        />
    );
}

export default VanTipsContent